// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"328":"96b92352","341":"96b92352"}[chunkId] + ".chunk.css");